import { render, staticRenderFns } from "./DescargarExcelAdmin.vue?vue&type=template&id=0dceb11c&scoped=true&"
import script from "./DescargarExcelAdmin.vue?vue&type=script&lang=js&"
export * from "./DescargarExcelAdmin.vue?vue&type=script&lang=js&"
import style0 from "./DescargarExcelAdmin.vue?vue&type=style&index=0&id=0dceb11c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dceb11c",
  null
  
)

export default component.exports